import { createFileRoute, notFound } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PcmpProposalPrintPage } from '@/features/pcmp/pages/PcmpProposalPrintPage';

export const Route = createFileRoute('/_print/pcmp/proposals/$proposalId/print')({
  parseParams: ({ proposalId }) => {
    const parsedId = Number(proposalId);
    if (!Number.isInteger(parsedId) || parsedId <= 0) throw notFound();
    return { proposalId: parsedId };
  },
  component: () => (
    <ErrorBoundary moduleName="PCMP Proposal Report">
      <PcmpProposalPrintPage />
    </ErrorBoundary>
  ),
});
